import { Link } from "react-router";
import { Helmet } from "react-helmet";

import JumpingGirl from "../assets/images/jumping-girl.svg";
import SittingGirl from "../assets/images/sitting-girl.svg";

const Home = () => {
  return (
    <main>
      <Helmet>
        <title>Provido</title>
        <meta property="og:title" content="Provido" />
        <meta
          name="description"
          content="We provide a variety of supports for people living with a disability."
        ></meta>
        <meta property="og:url" content="https://provido.com.au/" />
        <meta name="twitter:title" content="Provido" />
      </Helmet>

      {/* Hero Banner */}
      <div className="bg-lightblue bg-[url(./assets/images/bubblebg.webp)] bg-repeat">
        <div className="mx-auto flex max-w-4xl flex-col items-center gap-4 px-8 py-8 xs:flex-row sm:py-8 md:py-12 lg:max-w-6xl lg:pt-26 lg:pb-30">
          <h2 className="text-center font-display text-4xl text-blue xs:text-left sm:text-5xl sm:leading-14 md:text-6xl md:leading-18 lg:text-7xl lg:leading-22">
            Every Journey Deserves the
            <br /> Right Support
          </h2>
          <img
            src={JumpingGirl}
            alt="Illustration: a girl jumping for joy."
            className="-mb-14 w-3xs xs:-my-16 sm:w-xs md:-my-20 md:w-sm lg:-mt-34 lg:-mb-38 lg:w-full"
          />
        </div>
      </div>

      {/* Services */}
      <div className="mx-auto my-12 grid max-w-6xl grid-cols-8 px-12 font-display sm:px-0">
        <div className="col-span-8 flex items-center justify-center sm:col-span-3 sm:mr-4 sm:border-r-2 sm:border-r-gray-100 sm:pr-4 lg:mr-8 lg:pr-8">
          <h2 className="text-center text-4xl leading-12 text-purple sm:text-right lg:text-5xl lg:leading-16">
            Services
            <br />
            We Provide
          </h2>
        </div>
        <div className="col-span-8 mx-4 py-4 sm:col-span-5">
          <div className="grid grid-cols-1 grid-rows-4 gap-2 md:grid-cols-2 md:grid-rows-2">
            <Link to="/services/support-with-daily-living">
              <div className="service-card">
                <span className="service-icon ph ph-[hand-heart--duotone]"></span>
                Support with Daily Living
              </div>
            </Link>
            <Link to="/services/community-access">
              <div className="service-card">
                <span className="service-icon ph ph-[storefront--duotone]"></span>
                Community Access
              </div>
            </Link>
            <Link to="/services/nursing">
              <div className="service-card">
                <span className="service-icon ph ph-[first-aid-kit--duotone]"></span>
                Nursing
              </div>
            </Link>
            <Link to="/services/transport">
              <div className="service-card">
                <span className="service-icon ph ph-[van--duotone]"></span>
                Transport
              </div>
            </Link>
            <Link to="/services/exercise-physiology">
              <div className="service-card">
                <span className="service-icon ph ph-[person-simple-tai-chi--duotone]"></span>
                Exercise Physiology
              </div>
            </Link>
            <Link to="/services/supported-independent-living">
              <div className="service-card">
                <span className="service-icon ph ph-[house-line--duotone]"></span>
                Supported Independent Living
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-skyblue bg-[url(./assets/images/darkbubblebg.webp)] bg-repeat pt-8">
        <div className="mx-auto flex w-dvw flex-row justify-between font-display md:max-w-4xl lg:max-w-5xl">
          <img
            src={SittingGirl}
            alt="Illustration: a girl sitting down."
            className="ml-6 w-xs xs:ml-10 sm:ml-30 md:w-lg lg:w-xl"
          />
          <div className="mr-6 -ml-96 flex w-2/3 flex-col justify-start pt-0 text-center xs:mr-10 xs:w-1/2 sm:mr-30 sm:pt-6">
            <h2 className="text-right text-2xl leading-7 text-white xs:text-3xl xs:leading-8 sm:pl-8 md:text-4xl md:leading-10 lg:text-5xl lg:leading-14">
              Get in touch to find out how we can support you
            </h2>
            <p className="mt-8 text-right">
              <Link
                to="/contact"
                className="rounded-xl bg-white px-4 py-2 font-display text-blue hover:bg-purple hover:text-white"
                title="Get in touch"
              >
                Contact Us Today
              </Link>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
